import { Loader2, ShieldX } from 'lucide-react'
import type { ReactNode } from 'react'
import { Button } from '@/components/ui/Button'
import { useFeatureAccess } from '../context/feature-access-state'

export function FeatureAccessBoundary({
  permission,
  children,
}: {
  permission: string
  children: ReactNode
}) {
  const { can, loading, error, refresh } = useFeatureAccess()

  if (loading) {
    return (
      <div className="grid min-h-[60vh] place-items-center" role="status">
        <Loader2 className="size-7 animate-spin text-accent" aria-hidden="true" />
        <span className="sr-only">Checking feature access</span>
      </div>
    )
  }

  if (!can(permission)) {
    return (
      <section className="mx-auto grid min-h-[60vh] max-w-xl place-items-center px-6 text-center">
        <div className="rounded-2xl border border-border-default bg-raised p-8 shadow-sm">
          <ShieldX className="mx-auto size-10 text-muted" aria-hidden="true" />
          <h1 className="mt-4 text-xl font-semibold text-primary">
            Feature access unavailable
          </h1>
          <p className="mt-2 text-sm text-secondary">
            This page requires <span className="font-mono">{permission}</span>{' '}
            in at least one application you can access.
          </p>
          {error && (
            <Button className="mt-5" variant="secondary" onClick={() => void refresh()}>
              Retry access check
            </Button>
          )}
        </div>
      </section>
    )
  }

  return children
}
